import axios from "axios";
import endpoints from "../endpoints";

export default {
  namespaced: true,
  // -----------------------------------------------------------------
  state: {
    endpoint: endpoints.raffle.endpoint,
    endpoint_serials: endpoints.raffle.endpoint_serials,
  },
  // -----------------------------------------------------------------
  getters: {
    endpoint: state => state.endpoint,
    endpoint_serials: state => state.endpoint_serials
  },
  // -----------------------------------------------------------------
  mutations: {},
  // -----------------------------------------------------------------
  actions: {
    fetch: (context, paginationData) => {
      let api =
        context.rootGetters["global/apiUrl"] + "/" + context.state.endpoint;

      return new Promise((resolve, reject) => {
        axios({
          url: api,
          data: paginationData,
          method: "POST"
        })
          .then(resp => {
            const r = resp.data;
            if (r.success) {
              if (r.data.rows == null) r.data.rows = [];
            }
            resolve(r);
          })
          .catch(err => {
            if (err.response && err.response.data) {
              if (typeof err.response.data === "string") {
                reject(err);
              } else {
                reject(err.response.data);
              }
            } else {
              reject(err);
            }
          });
      });
    },
    fetch_serials: (context, paginationData) => {
      let api =
        context.rootGetters["global/apiUrl"] + "/" + context.state.endpoint_serials;

      return new Promise((resolve, reject) => {
        axios({
          url: api,
          data: paginationData,
          method: "POST"
        })
          .then(resp => {
            const r = resp.data;
            if (r.success) {
              if (r.data.rows == null) r.data.rows = [];
            }
            resolve(r);
          })
          .catch(err => {
            if (err.response && err.response.data) {
              if (typeof err.response.data === "string") {
                reject(err);
              } else {
                reject(err.response.data);
              }
            } else {
              reject(err);
            }
          });
      });
    }
  }
};
